import { dashboardTypeToEntityType } from "./shared/dashboardTypeToEntityType";
import { DatapointsEntityType, EntityType } from "api/ux/src";
import { useCurrentDashboardType } from "components/workspaces/hooks/use-current-dashboard";
export const useCurrentDatapointContext = () => {
    const currentEntityType = dashboardTypeToEntityType(useCurrentDashboardType());
    switch (currentEntityType) {
        case DatapointsEntityType.Asset:
            return EntityType.Asset;
        case DatapointsEntityType.Fund:
            return EntityType.Fund;
        case DatapointsEntityType.FundSeries:
            return EntityType.FundSeries;
        case DatapointsEntityType.Manager:
            return EntityType.Manager;
        case DatapointsEntityType.Portfolio:
            return EntityType.Portfolio;
        case DatapointsEntityType.Market:
            return EntityType.Market;
        default:
            return null;
    }
};
